import {CheckCheck} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const DoneAllIcon = createLucideIcon(CheckCheck, 'DoneAllIcon');
